import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { getObjectStorageAction, getObjectStorageFormData, getUploadParams } from './service.js';
import dayjs from 'dayjs';

const OSSUpload = ({
  onChange,
  value,
  buttonText,
  folderId,
  bucket = 'savvyuni-intl-erp',
  addTimestamp,
  ...rest
}) => {
  const [ossData, setOssData] = useState();
  const [fileList, setFileList] = useState([]);
  const uploadAction = getObjectStorageAction(bucket, ossData);

  useEffect(() => {
    if (!value) {
      setFileList([]);
    } else {
      if (Array.isArray(value)) {
        setFileList(value);
      } else {
        setFileList([value]);
      }
    }
  }, [value]);

  const handleBeforeUpload = async (file) => {
    if (addTimestamp) {
      file.url = `${dayjs().format('YYYYMMDDHHmmss')}_${file.name}`;
    }
    return file;
  };

  const getOSSAuth = async (file) => {
    if (!ossData || new Date().getTime() > ossData.expire) {
      const res = await getUploadParams({
        folderId,
        bucket,
      });
      setOssData(res);
      return getObjectStorageFormData(
        res,
        `${res.dir}/${addTimestamp && file.url ? file.url : file.name}`,
        bucket,
      );
    } else {
      return getObjectStorageFormData(
        ossData,
        `${ossData.dir}/${addTimestamp && file.url ? file.url : file.name}`,
        bucket,
      );
    }
  };

  const onUploadChange = ({ file }) => {
    let newFileList = [];
    if (file.status === 'removed') {
      newFileList = [...fileList.filter((f) => f.uid !== file.uid)];
    } else {
      if (fileList.some((f) => f.uid === file.uid)) {
        newFileList = [
          ...fileList.map((f) => {
            if (f.uid === file.uid) {
              const newFile = {
                ...f,
                ...file,
              };
              if (file.status === 'done') {
                newFile.bucket = bucket;
                newFile.key = `${ossData.dir}/${addTimestamp && file.url ? file.url : file.name}`;
              }
              return newFile;
            }
            return f;
          }),
        ];
      } else {
        newFileList = [...fileList, file];
      }
    }
    if (rest.maxCount && newFileList.length > rest.maxCount) {
      newFileList = newFileList.splice(newFileList.length - rest.maxCount);
    }
    setFileList(newFileList);
    if (onChange && typeof onChange === 'function') {
      if (rest.maxCount === 1) {
        onChange(newFileList[0]);
      } else {
        onChange(newFileList);
      }
    }
  };

  return (
    <Upload
      action={uploadAction}
      data={getOSSAuth}
      fileList={fileList}
      onChange={onUploadChange}
      beforeUpload={handleBeforeUpload}
      {...rest}
    >
      <Button icon={<UploadOutlined />} {...rest}>
        {buttonText || '点击上传'}
      </Button>
    </Upload>
  );
};

export default OSSUpload;
